/** Controls interactions on the pre-sale landing page. */
(function(){
        var tabs=Array.prototype.slice.call(document.querySelectorAll('.w2s-tab'));
        var panels=Array.prototype.slice.call(document.querySelectorAll('.w2s-panel'));
        function activate(tab,moveFocus){
          tabs.forEach(function(item){var active=item===tab;item.setAttribute('aria-selected',active?'true':'false');item.tabIndex=active?0:-1});
          panels.forEach(function(panel){var active=panel.id===tab.getAttribute('aria-controls');panel.hidden=!active;panel.classList.toggle('is-active',active)});
          if(moveFocus){tab.focus()}
          tab.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest',inline:'center'});
        }
        tabs.forEach(function(tab,index){
          tab.addEventListener('click',function(){activate(tab,false)});
          tab.addEventListener('keydown',function(event){
            var next=index;
            if(event.key==='ArrowRight')next=(index+1)%tabs.length;
            else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
            else if(event.key==='Home')next=0;
            else if(event.key==='End')next=tabs.length-1;
            else return;
            event.preventDefault();activate(tabs[next],true);
          });
        });
      })();

// ── Show More ──────────────────────────────────────────────
  var shown = 0;
  var batch = 5;
  
  window.showMore = function() {
    var extras = document.querySelectorAll('.extra-comment');
    var next = Math.min(shown + batch, extras.length);
    for (var i = shown; i < next; i++) {
      extras[i].style.display = 'block';
    }
    shown = next;
    if (shown >= extras.length) {
      document.getElementById('show-more-wrap').style.display = 'none';
    }
    var btn = document.getElementById('show-more-btn');
    var remaining = extras.length - shown;
    if (remaining > 0) {
      var label = btn.dataset.label || 'View more comments';
      btn.innerHTML = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 3v10M3 8l5 5 5-5" stroke="#050505" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> ' + label + ' (' + remaining + ' remaining)';
    }
    window.initLikes();
  };
  
  // ── Like (one per comment, toggleable, persisted) ──────────
  var LIKE_STORAGE_KEY = 'lp-pre-sale-bridge-likes';

  function getLikedIds() {
    try {
      var raw = localStorage.getItem(LIKE_STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveLikedIds(ids) {
    try {
      localStorage.setItem(LIKE_STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function findReactionPill(actionsEl) {
    if (!actionsEl) return null;
    var sib = actionsEl.previousElementSibling;
    while (sib) {
      var pill = sib.querySelector('.reaction-pill, .reply-reaction-pill');
      if (pill) return pill;
      sib = sib.previousElementSibling;
    }
    return null;
  }

  function findBubbleRow(actionsEl) {
    if (!actionsEl) return null;
    var bubbleRow = actionsEl.previousElementSibling;
    while (
      bubbleRow &&
      !bubbleRow.classList.contains('bubble-row') &&
      !bubbleRow.classList.contains('reply-bubble-row')
    ) {
      bubbleRow = bubbleRow.previousElementSibling;
    }
    return bubbleRow;
  }

  function applyLikedState(btn) {
    var actionsEl = btn.closest('.comment-actions, .reply-actions');
    btn.classList.add('liked');

    var pill = findReactionPill(actionsEl);
    if (pill) {
      pill.style.display = '';
      var countEl = pill.querySelector('span:last-child');
      if (countEl) countEl.textContent = '1';
      return;
    }

    var bubbleRow = findBubbleRow(actionsEl);
    if (!bubbleRow) return;

    var newPill = document.createElement('div');
    newPill.className = bubbleRow.classList.contains('reply-bubble-row')
      ? 'reply-reaction-pill'
      : 'reaction-pill';
    newPill.innerHTML = '<span>👍</span><span style="margin-left:2px">1</span>';
    bubbleRow.appendChild(newPill);
  }

  function clearLikedState(btn) {
    btn.classList.remove('liked');

    var pill = findReactionPill(btn.closest('.comment-actions, .reply-actions'));
    if (pill) pill.remove();
  }

  window.initLikes = function() {
    var likedIds = getLikedIds();

    document.querySelectorAll('[data-review-action="like"]').forEach(function(btn) {
      var commentEl = btn.closest('[data-comment-id]');
      var commentId = commentEl && commentEl.getAttribute('data-comment-id');
      if (!commentId) return;

      if (likedIds.indexOf(commentId) !== -1 && !btn.classList.contains('liked')) {
        applyLikedState(btn);
      }

      if (btn.dataset.likeWired) return;
      btn.dataset.likeWired = '1';

      btn.addEventListener('click', function() {
        var ids = getLikedIds();
        var storedIndex = ids.indexOf(commentId);

        if (btn.classList.contains('liked')) {
          clearLikedState(btn);
          if (storedIndex !== -1) {
            ids.splice(storedIndex, 1);
            saveLikedIds(ids);
          }
          return;
        }

        applyLikedState(btn);
        btn.classList.add('just-liked');
        btn.addEventListener('animationend', function() {
          btn.classList.remove('just-liked');
        }, { once: true });

        if (storedIndex === -1) {
          ids.push(commentId);
          saveLikedIds(ids);
        }
      });
    });
  };

  window.initLikes();

window.__tqSecReady=window.__tqSecReady||function(f){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',f);else f();};
  window.__tqSecReady(function(){
   document.querySelectorAll('.cta').forEach(function(link){link.addEventListener('click',function(){window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'water2skin_bridge_cta_click',placement:link.getAttribute('data-placement')||'unknown'})})});

   var videos = document.querySelectorAll('.video-grid video');
   if (!videos.length) return;

   function armVideo(video) {
     video.muted = true;
     video.defaultMuted = true;
     video.playsInline = true;
     video.setAttribute('muted', '');
     video.setAttribute('playsinline', '');
     video.setAttribute('webkit-playsinline', '');
   }

   function tryPlay(video) {
     armVideo(video);
     var playPromise = video.play();
     if (playPromise && typeof playPromise.catch === 'function') {
       playPromise.catch(function() {});
     }
   }

   function tryPlayAll() {
     Array.prototype.forEach.call(videos, tryPlay);
   }

   Array.prototype.forEach.call(videos, function(video) {
     armVideo(video);
     video.addEventListener('loadeddata', function() {
       tryPlay(video);
     });
     video.addEventListener('canplay', function() {
       tryPlay(video);
     });
   });

   tryPlayAll();

   document.addEventListener('touchstart', tryPlayAll, { once: true, passive: true });
   document.addEventListener('click', tryPlayAll, { once: true });
   document.addEventListener('visibilitychange', function() {
     if (document.visibilityState === 'visible') tryPlayAll();
   });

   if (!('IntersectionObserver' in window)) return;

   var observer = new IntersectionObserver(function(entries) {
     entries.forEach(function(entry) {
       var video = entry.target.tagName === 'VIDEO'
         ? entry.target
         : entry.target.querySelector('video');
       if (!video) return;
       if (entry.isIntersecting) tryPlay(video);
     });
   }, { rootMargin: '80px 0px', threshold: 0 });

   Array.prototype.forEach.call(videos, function(video) {
     observer.observe(video.closest('.testimonials__media') || video);
   });

   document.querySelectorAll('.install-grid img').forEach(function(img) {
     img.addEventListener('error', function() {
       var src = img.getAttribute('src') || '';
       if (!src || src.indexOf('format=gif') !== -1) return;
       img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'format=gif';
     });
   });
  });
